import TagsList from './TagsList';

export default TagsList;
